import React from "react";
import { Stack, Text, Button } from "@mantine/core";
import { IconArrowLeft } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import SubscriptionPricing from "../SubscriptionPricing";

function SubscriptionSettingsPage() {
  const navigate = useNavigate();

  return (
    <Stack gap="md" py="md">
      <Button
        variant="subtle"
        leftSection={<IconArrowLeft size={16} />}
        onClick={() => navigate("/admin/settings/studio")}
        w="fit-content"
        c="dimmed"
      >
        Back to Studio Settings
      </Button>
      <SubscriptionPricing />
    </Stack>
  );
}

export default SubscriptionSettingsPage;
